var map = {
	"./Cisco.png": 5343,
	"./Google.png": 2765,
	"./Meta.png": 9591,
	"./Netflix.png": 9502,
	"./Oracle.png": 6506,
	"./Pinterest.png": 5068,
	"./Spotify.png": 3968,
	"./Walmart.png": 1490,
	"./pngwing.com.png": 9823
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5035;